import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Header } from 'components/Payment/PaymentCardItem/styles';

export const Flag: any = styled.div`
  width: 48px;
  margin-right: 14px;
  position: relative;
`;

interface FlagProps {
  src: string;
}

Flag.Icon = styled(Header.Icon)``;

Flag.Image = styled.div.attrs<any, FlagProps>((): any => ({}))`
  width: 20px;
  height: 13px;
  position: absolute;
  bottom: -2px;
  right: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-image: ${({ src }) => `url(${src})`};
  background-size: cover;
  border-radius: 2px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
`;
